export default {
    unlock: 'hordeClassShaman',
    icon: 'mdi-tree',
    baseStats: {
        attack: 4.4,
        health: 575,
        mana: 150
    },
    exp: {
        base: 4200,
        increment: 1.425
    },
    skills: {},
    skillTree: [
        {isInnate: true, level: 0, items: []},
    ],
    quests: {
        stat: [],
        zone: [],
        level: [],
        boss: []
    }
}
